import { Paper, Typography } from "@mui/material";
import type { ReactNode } from "react";

type FormSectionProps = {
  title: string;
  children: ReactNode;
  subtitle?: string;
};

export const FormSection = ({ title, children, subtitle }: FormSectionProps) => (
  <Paper variant="outlined" sx={{ p: 2.5, mb: 2, width: "100%" }}>
    <Typography variant="subtitle1" fontWeight={600} gutterBottom>
      {title}
    </Typography>
    {subtitle ? (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {subtitle}
      </Typography>
    ) : null}
    {children}
  </Paper>
);
